// extracted by mini-css-extract-plugin
export var pagePressWall = "ContentfulBlockPressWall-module--pagePressWall--jjFZo";
export var presses = "ContentfulBlockPressWall-module--presses--Zq41U";
export var pressItem = "ContentfulBlockPressWall-module--pressItem--eR4PW";